// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background-color: #2B2B2B;
  color: white;
  padding: 2rem 0;
  font-family: 'Josefin Sans', sans-serif;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr;
  gap: 2rem;
  align-items: start;
}

.footer-logo-section {
  padding: 1rem;
}

.footer-logo {
  width: 180px;
  height: auto;
}

.footer-newsletter {
  text-align: center;
  padding: 0 1rem;
}

.newsletter-title {
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: white;
}

.newsletter-description {
  color: #f5f5f5;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
}

.newsletter-form {
  display: flex;
  gap: 0.5rem;
  max-width: 400px;
  margin: 0 auto;
}

.newsletter-input {
  flex: 1 1;
  padding: 0.75rem;
  border: none;
  border-radius: 4px;
  background: #444444;
  color: white;
  font-family: 'Josefin Sans', sans-serif;
}

.newsletter-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.newsletter-button {
  padding: 0.75rem 1.5rem;
  background-color: var(--color-gold);
  border: none;
  border-radius: 4px;
  color: white;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.newsletter-button:hover {
  background-color: var(--color-olive);
}

.footer-quick-links {
  padding: 1rem;
}

.quick-links-title {
  color: var(--color-gold);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

.quick-links-list {
  column-count: 3;
  column-gap: 2rem;
}

.footer-link {
  color: #f5f5f5;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
  display: block;
  margin-bottom: 1rem;
}

.footer-link:hover {
  color: var(--color-gold);
}

@media (max-width: 1024px) {
  .footer-container {
    grid-template-columns: 1fr 1.5fr 1fr;
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 2rem 0;
  }

  .footer-container {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }

  .footer-logo-section {
    display: flex;
    justify-content: center;
  }

  .quick-links-list {
    column-count: 3;
    max-width: 600px;
    margin: 0 auto;
  }
}

@media (max-width: 480px) {
  .quick-links-list {
    column-count: 1;
    max-width: 300px;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,oCAAoC;IACpC,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".footer {\n  background-color: #2B2B2B;\n  color: white;\n  padding: 2rem 0;\n  font-family: 'Josefin Sans', sans-serif;\n}\n\n.footer-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: grid;\n  grid-template-columns: 1fr 1.5fr 1fr;\n  gap: 2rem;\n  align-items: start;\n}\n\n.footer-logo-section {\n  padding: 1rem;\n}\n\n.footer-logo {\n  width: 180px;\n  height: auto;\n}\n\n.footer-newsletter {\n  text-align: center;\n  padding: 0 1rem;\n}\n\n.newsletter-title {\n  font-size: 1.75rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: white;\n}\n\n.newsletter-description {\n  color: #f5f5f5;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  margin-bottom: 1.5rem;\n}\n\n.newsletter-form {\n  display: flex;\n  gap: 0.5rem;\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.newsletter-input {\n  flex: 1;\n  padding: 0.75rem;\n  border: none;\n  border-radius: 4px;\n  background: #444444;\n  color: white;\n  font-family: 'Josefin Sans', sans-serif;\n}\n\n.newsletter-input::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.newsletter-button {\n  padding: 0.75rem 1.5rem;\n  background-color: var(--color-gold);\n  border: none;\n  border-radius: 4px;\n  color: white;\n  font-family: 'Josefin Sans', sans-serif;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.newsletter-button:hover {\n  background-color: var(--color-olive);\n}\n\n.footer-quick-links {\n  padding: 1rem;\n}\n\n.quick-links-title {\n  color: var(--color-gold);\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n}\n\n.quick-links-list {\n  column-count: 3;\n  column-gap: 2rem;\n}\n\n.footer-link {\n  color: #f5f5f5;\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.3s ease;\n  display: block;\n  margin-bottom: 1rem;\n}\n\n.footer-link:hover {\n  color: var(--color-gold);\n}\n\n@media (max-width: 1024px) {\n  .footer-container {\n    grid-template-columns: 1fr 1.5fr 1fr;\n    gap: 1.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer {\n    padding: 2rem 0;\n  }\n\n  .footer-container {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    text-align: center;\n  }\n\n  .footer-logo-section {\n    display: flex;\n    justify-content: center;\n  }\n\n  .quick-links-list {\n    column-count: 3;\n    max-width: 600px;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 480px) {\n  .quick-links-list {\n    column-count: 1;\n    max-width: 300px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
